var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnassignCrystal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1144_9777)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.571952 4.39344L4.2603 0L7.16155 3.26067L6.24446 7.68434C6.51192 7.28852 6.83113 6.93054 7.19237 6.6201C7.18125 6.58995 7.17 6.55897 7.1586 6.52707L8.24312 4.71692L8.90098 5.63255C9.45361 5.43873 10.0478 5.33333 10.6667 5.33333C13.6122 5.33333 16 7.72115 16 10.6667C16 13.6122 13.6122 16 10.6667 16C9.75263 16 8.8923 15.7701 8.14036 15.3649L7.99119 16H6.38631L5.71313 15.2393C5.74332 15.0503 5.81742 14.8459 5.89477 14.6325C5.95372 14.4698 6.01456 14.302 6.05928 14.1318H6.61225C6.39844 13.8819 6.20735 13.612 6.04215 13.3252H1.03674C-0.288951 12.6539 -0.377259 10.7378 0.968743 10.1162L0.975986 10.1155H5.36147C5.38007 9.93431 5.40774 9.75584 5.44401 9.58051H4.24648L3.89891 6.91126L5.98796 3.18602L4.41462 1.28474L5.18836 3.10886L3.50255 5.78102L1.34554 5.0229L3.1638 6.8985L3.17657 9.58051H1.5717L0.571952 4.39344ZM7.49884 14.9577L7.50004 14.9858L7.50754 14.9641L7.49884 14.9577ZM2.08359 14.131L2.64161 16H5.3164L5.62173 14.1358L4.77449 14.1258L4.38154 15.7686L3.80632 14.1372L2.08359 14.131ZM15.3333 10.6667C15.3333 13.244 13.244 15.3333 10.6667 15.3333C8.08934 15.3333 6 13.244 6 10.6667C6 8.08934 8.08934 6 10.6667 6C13.244 6 15.3333 8.08934 15.3333 10.6667ZM8 9.33333C7.63181 9.33333 7.33333 9.63181 7.33333 10V11.3333C7.33333 11.7015 7.63181 12 8 12H13.3333C13.7015 12 14 11.7015 14 11.3333V10C14 9.63181 13.7015 9.33333 13.3333 9.33333H8Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1144_9777"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "current"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnassignCrystal);
export default __webpack_public_path__ + "static/media/UnassignCrystal.2049fdee724fc6516fadef370d2adaf3.svg";
export { ForwardRef as ReactComponent };